import React from 'react';

function RequestAccessSent() {
    return (
        <div className="loginBoxContainer requestAccessSuccess">
            <div className="requestAccessSuccessGrid">
                <div className="requestAccessSuccessImg">
                    <img src='img/aon_success_icon.svg' alt='success' />
                </div>
                <div className="requestAccessSuccessContentFormContainer">
                    <h2>Request for new account was sent</h2>
                    <p>
                        Please wait for our approval.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default RequestAccessSent;
